<template>
  <div class="itemain">
    <div class="itemtitle">
      <b>{{title}}</b>
    </div>
    <input
      style="border: none;
    border-bottom: 2px solid black;
    width: 100%;"
      v-if="type != 'textarea'"
      v-model="value"
      :name="name"
      :type="type"
      :focus="focus"
      :class="inputClass"
      :style="inputStyle"
      :disabled="disabled"
      :password="password"
      :confirm-type="confirmType"
      :maxlength="maxLength"
      :placeholder="placeholder"
      :placeholder-style="placeholderStyle"
      :placeholder-class="placeholderClass"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
export default {
  name: "input",
  props: {
    title: {
      type: Object | String,
    },
    // // 初始值
    // value: {
    //   type: String | Number,
    //   default: ""
    // },
    // 必填星号
    required: Boolean,
    // 是否密码类型输入
    password: Boolean,
    // 是否禁用
    disabled: Boolean,
    // 初始获得焦点
    focus: Boolean,
    // textarea 自动高度
    autoHeight: Boolean,
    // 是否可清空
    clearable: Boolean,

    // 输入框占位
    placeholder: {
      type: String,
      default: ""
    },
    // 原生属性
    name: {
      type: String,
      default: ""
    },

    // 原生属性
    type: {
      type: String,
      default: "text"
    },
    // 标题长
    titleNum: {
      type: Number | String,
      default: 4
    },
    // 最大输入字符数
    maxLength: {
      type: Number,
      default: -1
    },

    // 自定义占位样式
    placeholderStyle: {
      type: String,
      default: ""
    },
    // 自定义占位类
    placeholderClass: {
      type: String,
      default: ""
    },

    // 软键盘右下角类型
    confirmType: {
      type: String,
      default: "done"
    },
    // 自定义类
    customClass: {
      type: String,
      default: ""
    },
    // 自定义标题类
    titleClass: {
      type: String,
      default: ""
    },
    // 自定义输入框类
    inputClass: {
      type: String,
      default: ""
    },
    // 自定义样式
    customStyle: {
      type: String,
      default: ""
    },
    // 自定义标题样式
    titleStyle: {
      type: String,
      default: ""
    },
    // 自定义输入框样式
    inputStyle: {
      type: String,
      default: ""
    },
    // 错误信息
    error: {
      type: String,
      default: ""
    },

  },
  data() {
    return {
      isFocus: false,
      value: ""
    }
  },
  methods: {
    /**
        * 输入
        */
    onInput(e) {
      this.$emit("input", this.value)
    },
    /**
     * 获得焦点
     */
    onFocus(e) {
      this.isFocus = true;
      this.$emit("focus", e)
    },
    /**
     * 失去焦点
     */
    onBlur(e) {
      setTimeout(() => {
        this.isFocus = false;
      }, 100);
      this.$emit("blur", e)
    },
    /**
     * 点击完成时触发
     */
    onConfirm(e) {
      this.$emit("confirm", e)
    },
    /**
     * 行数变化
     */
    onLinechange(e) {
      this.$emit("linechange", e)
    },
    /**
     * 点击
     */
    onTap(e) {
      this.$emit("click", e);
    },
    /**
     * 清除输入
     */
    onClear(e) {
      this.$emit("clean", e);
      let temp = { currentTarget: e.currentTarget, type: "input", detail: { value: "" } };
      this.onInput(temp)
    },
  }
}
</script>

<style>
.itemain {
  width: 100%;
  max-width: 45%;
  flex: 0 0 45%;
  height: 1rem;
  font-size: 0.225rem;
  margin-bottom: 0.8rem;
}
.itemtitle {
  margin-bottom: 0.15rem;
}

.itemain input:focus {
  outline: medium;
}
</style>



// WEBPACK FOOTER //
// src/components/input-item.vue